/**
 * Star API Client
 * Manages email star/unstar functionality with Gmail sync
 */

import { getStoredSessionId } from './auth-client';

const CF_WORKER_URL = import.meta.env.VITE_CLOUDFLARE_WORKER_URL || '';
const API_BASE = CF_WORKER_URL ? `${CF_WORKER_URL}/api` : '/api';

function getAuthHeaders(): HeadersInit {
  const sessionId = getStoredSessionId();
  return sessionId ? { 'X-Session-Id': sessionId } : {};
}

/**
 * Toggle star status for an email
 * Updates local database and syncs with Gmail
 */
export async function toggleStar(
  gmailMessageId: string,
  starred: boolean
): Promise<{ success: boolean }> {
  const response = await fetch(`${API_BASE}/star`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ gmailMessageId, starred }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error?.message || 'Failed to update star');
  }

  return { success: true };
}
